// extracted by mini-css-extract-plugin
module.exports = {"color-white":"theme_color-white__6ckBa","color-black":"theme_color-black__2qU2Q","color-default-gray":"theme_color-default-gray__2tPjz","default":"theme_default__RUy79"};